<script setup lang="ts">
import Button from '@/components/ui/Button.vue'
import EmptyState from '@/components/ui/EmptyState.vue'
import { HOME_ROUTE } from '@/config/routes'
</script>

<template>
  <EmptyState
    icon="search"
    title="Page not found"
    description="That URL does not match anything in the admin panel."
  >
    <template #action>
      <Button :to="HOME_ROUTE">Back to dashboard</Button>
    </template>
  </EmptyState>
</template>
